export const ROLES = {
    SHEDULER: 'SCHEDULER',
    ADMIN: 'ADMIN',
    OPS_TEAM: 'OPS_TEAM',
    STAKE_HOLDERS: 'STAKEHOLDERS',
    PROVIDER: 'PROVIDER',
    TENANT_ADMIN: 'TENANT_ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
}

export const USER_TYPES = {
    PROVIDER: 'Provider',
    NON_PROVIDER: 'Non-Provider',
}
